export default {
	devTools: 'Dev tools',
	hideDevTools: 'Hide dev tools',
	onlyVisibleToDevAccounts: 'Only visible to dev accounts.',
	showDevTools: 'Show dev tools',
	showEvSpecification: 'Show EV battery & charging',
};
